import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Clock, Loader2 } from "lucide-react";
import { API, SLOT_LABEL, auth } from "./practiceApi";

// Change when reminders arrive (holidays, new routine). Also follows the phone's current time zone.
export const ReminderTimes = ({ p, onChange, onClose }) => {
  const slots = [...new Set([...(p.slots || []), ...(p.night ? ["night"] : [])])].filter((s) => p.times?.[s]);
  const [times, setTimes] = useState(() => Object.fromEntries(slots.map((s) => [s, p.times[s]])));
  const [busy, setBusy] = useState(false);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await axios.patch(`${API}/api/practice`, { times, tz }, auth());
      onChange(data);
      toast.success("Reminder times updated.");
      onClose();
    } catch { toast.error("We couldn't save those times. Please try again."); }
    setBusy(false);
  };
  return (
    <div className="mt-3 space-y-2" data-testid="practice-times-editor">
      {slots.map((s) => (
        <label key={s} className="flex items-center justify-between rounded-xl border border-[#2b3d5e] px-3 py-2 text-sm text-[#cfc6ae]">{SLOT_LABEL[s] || s}
          <input type="time" value={times[s]} onChange={(e) => setTimes({ ...times, [s]: e.target.value })} className="bg-transparent text-[#f3ecd9]" data-testid={`practice-edit-time-${s}`} />
        </label>
      ))}
      {tz !== p.tz && <p className="text-xs text-[#9fb39a]" data-testid="practice-times-tz">Your phone is now on {tz.replace(/_/g, " ")} time. Saving will move your reminders to local time there.</p>}
      <div className="flex gap-2 pt-1">
        <button type="button" onClick={save} disabled={busy} data-testid="practice-times-save"
          className="inline-flex items-center gap-1.5 rounded-full bg-[#d7bb7a] px-4 py-2 text-xs font-semibold text-[#0b1a33] disabled:opacity-50">{busy ? <Loader2 size={12} className="animate-spin" /> : <Clock size={12} />} Save times</button>
        <button type="button" onClick={onClose} className="rounded-full px-3 py-2 text-xs text-[#cfc6ae]" data-testid="practice-times-cancel">Cancel</button>
      </div>
    </div>
  );
};
